import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  /**
   * Codifica `{EmpresaId, OrgId, UserId}` como JSON UTF-8 → Base64 y lo concatena
   * con el `dominio` separados por `|`. Formato: `<base64Payload>|<dominio>`.
   */
  public enviarIdentificadorCodificado(
    idEmpresa: number,
    idUsuario: string,
    idOrganizacion: number,
    dominio: string
  ): string {
    const payload = {
      EmpresaId: idEmpresa,
      OrgId: idOrganizacion,
      UserId: idUsuario
    };

    const jsonPayload = JSON.stringify(payload);
    const utf8Encoded = new TextEncoder().encode(jsonPayload);
    const base64Payload = btoa(String.fromCharCode(...utf8Encoded));
    return `${base64Payload}|${dominio}`;
  }
}
